if (!customElements.get('wlsn-product-options-modal')) {
    class WLSNProductOptionsModal extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          tabs: 'js-wlsn-product-options-tab',
          panels: 'js-wlsn-product-options-panel',
          closeBtn: 'js-wlsn-product-options-modal-close',
          activeClass: 'is-active',
          trigger: 'js-wlsn-product-options-modal-trigger'
        };

        this.elements = {
          tabs: this.querySelectorAll(`.${this.classes.tabs}`),
          panels: this.querySelectorAll(`.${this.classes.panels}`),
          closeBtn: this.querySelector(`.${this.classes.closeBtn}`)
        };
      }

      connectedCallback() {
        this.init();
        this.initTriggers();
      }

      init() {
        // Tab click
        this.elements.tabs.forEach(tab => {
          tab.addEventListener('click', () => this.selectTab(tab.dataset.plan));
        });

        // Close button click
        this.elements.closeBtn?.addEventListener('click', () => {
          this.closeModal();
        });

        // Click outside modal to close
        this.addEventListener('click', (e) => {
          if (e.target === this) {
            this.closeModal();
          }
        });
      }

      selectTab(plan) {
        this.elements.tabs.forEach(tab => {
          const isActive = tab.dataset.plan === plan;
          tab.classList.toggle(this.classes.activeClass, isActive);
          tab.setAttribute('aria-selected', isActive);
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.elements.panels.forEach(panel => {
          panel.hidden = panel.dataset.plan !== plan;
        });
      }

      openModal() {
        this.classList.add(this.classes.activeClass);
        document.body.style.overflow = 'hidden';
      }

      closeModal() {
        this.classList.remove(this.classes.activeClass);
        document.body.style.overflow = '';

        if (this.elements.tabs.length) {
          this.selectTab(this.elements.tabs[0].dataset.plan);
        }
      }

      initTriggers() {
        document.addEventListener('click', (e) => {
          const trigger = e.target.closest(`.${this.classes.trigger}`);
          if (!trigger) return;
      
          e.preventDefault();
          this.openModal();
        });
      }
    }

    customElements.define('wlsn-product-options-modal', WLSNProductOptionsModal);
}
